import { render, staticRenderFns } from "./BuyerRegister.vue?vue&type=template&id=69df6c94&scoped=true"
import script from "./BuyerRegister.vue?vue&type=script&lang=js"
export * from "./BuyerRegister.vue?vue&type=script&lang=js"
import style0 from "./BuyerRegister.vue?vue&type=style&index=0&id=69df6c94&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69df6c94",
  null
  
)

export default component.exports